import { swiperMv, swiperInterview, swiperShortMovie } from "../modules/swiper";
import {
  elementSizeModifyPcTab,
  elementSizeModifySp,
  elementSizeModify,
  is_Mobile,
  observeAutoHeight,
  remToPx,
} from "../common";
import { videoModal } from "../modules/video-modal";
export const initTop = () => {
  swiperMv();
  swiperShortMovie();
  customTagClick();
  initTagElement();
  const ManyColumnPc = 3;
  const ManyColumnSp = 2;
  const postTitle = "js-new-post-item-ttl";
  // elementSizeModifyPcTab(postTitle, ManyColumnPc);
  // elementSizeModifySp(postTitle, ManyColumnSp);

  const newPostTagSp = "js-new-post-item-tag-sp";
  const postBox = document.querySelector("#js-new-post-box-sp");
  let newPostNum = 0;
  if (postBox) {
    newPostNum = postBox.getAttribute("data-new-post-num");
  }
  // elementSizeModifySp(newPostTagSp, newPostNum);
  const postPopularTitle = "js-popular-post-item-ttl";
  // elementSizeModifyPcTab(postPopularTitle, ManyColumnPc);
  videoModal();

  // インタビュー記事調整-start
  const postInterviewTtl = "js-top-interview-item-ttl";
  const postInterviewTag = "js-top-interview-item-tag";
  const interviewBox = document.querySelector("#js-interview-post-box");
  let newInterviewNum = 0;
  if (interviewBox) {
    newInterviewNum = interviewBox.getAttribute("data-interview-post-num");
  }
  swiperInterview()
    .then((swiper) => {
      elementSizeModify(postInterviewTtl, newInterviewNum);
      elementSizeModify(postInterviewTag, newInterviewNum);
      // 1秒後に再度実行
      setTimeout(() => {
        elementSizeModify(postInterviewTtl, newInterviewNum);
        elementSizeModify(postInterviewTag, newInterviewNum);
      }, 1000);

      // 5秒後に再度実行
      setTimeout(() => {
        elementSizeModify(postInterviewTtl, newInterviewNum);
        elementSizeModify(postInterviewTag, newInterviewNum);
      }, 5000);
    })
    .catch((error) => {
      console.error("Swiperの設定に失敗しました:", error);
    });
  // インタビュー記事調整-end

  window.addEventListener("resize", resizeWindow);
  const topInterviewLink = "js-top-interview-item a";
  linkClickCancel(topInterviewLink);
  const topMvInterviewLink = "js-top-mv-interview-link";
  linkClickCancel(topMvInterviewLink);

  function resizeWindow() {
    // タイトル見出し調整
    // elementSizeModifyPcTab(postTitle, ManyColumnPc);
    // elementSizeModifySp(newPostTagSp, ManyColumnSp);

    // インタビュー記事調整
    // elementSizeModify(postInterviewTtl, newInterviewNum);
    // elementSizeModify(postInterviewTag, newInterviewNum);

    // elementSizeModifyPcTab(postPopularTitle, ManyColumnPc);
    // elementSizeModifySp(postPopularTitle, ManyColumnSp);
  }
  observeAutoHeight("js-new-post-item-ttl", {
    containerSelector: ".post-card__items",
    columnPc: 3,
    columnSp: 2
  });

};

const linkClickCancel = (linkClass) => {
  const links = document.querySelectorAll(`.${linkClass}`);
  if (links) {
    links.forEach((link) => {
      link.addEventListener("dragstart", function (event) {
        event.preventDefault();
      });
    });
  }
};

const customTagClick = () => {
  const parentTags = document.querySelector("#js-custom-post-tag");
  const posts = document.querySelectorAll(".js-custom-post-type-item");
  const postBtns = document.querySelectorAll(".js-popular-post-btn");
  const ManyColumnPc = 3;
  const ManyColumnSp = 2;

  if (parentTags) {
    let tags = parentTags.querySelectorAll("li");
    const linkElement = document.querySelector("#js-dynamic-link");

    tags.forEach((tag, index) => {
      tag.addEventListener("click", function () {
        tags.forEach((t) => {
          t.classList.remove("active");
        });
        posts.forEach((post) => {
          post.classList.remove("active");
        });
        postBtns.forEach((btn) => {
          btn.style.display = "none";
        });
        postBtns[index].style.display = "inline-block";
        const indexSp = index + postBtns.length / 2;
        postBtns[indexSp].style.display = "inline-flex";

        posts[index].classList.add("active");
        this.classList.add("active");

        const postTitle = "js-new-post-item-ttl";
        elementSizeModifyPcTab(postTitle, ManyColumnPc);
        elementSizeModifySp(postTitle, ManyColumnSp);
      });
    });
  }
};

const initTagElement = () => {
  const parentTags = document.querySelector("#js-custom-post-tag");
  const posts = document.querySelectorAll(".js-custom-post-type-item");
  const postBtns = document.querySelectorAll(".js-popular-post-btn");
  const ManyColumnPc = 3;
  const ManyColumnSp = 2;

  if (parentTags) {
    const tags = parentTags.querySelectorAll("li");

    tags.forEach((tag, index) => {
      tag.addEventListener("click", () => {
        posts.forEach((post) => {
          post.classList.remove("active");
        });
        postBtns.forEach((btn) => {
          btn.style.display = "none";
        });
        postBtns[index].style.display = "inline-block";
        const indexSp = index + postBtns.length / 2;
        postBtns[indexSp].style.display = "inline-flex";

        posts[index].classList.add("active");
        tag.classList.add("active");

        const postTitle = "js-new-post-item-ttl";
        elementSizeModifyPcTab(postTitle, ManyColumnPc);
        elementSizeModifySp(postTitle, ManyColumnSp);
      });
    });
  }

  const tagButtons = document.querySelectorAll('#js-custom-post-tag li');

  tagButtons.forEach((tag, index) => {
    tag.addEventListener('click', () => {
      // 表示切替処理（例: .activeクラスの付け替えなど）
      document.querySelectorAll('.your-post-block').forEach((block, i) => {
        block.style.display = i === index ? 'block' : 'none';
      });

      // ✅ 高さ調整（表示切替後に実行）
      const device = is_Mobile();
      const columnNum = device === 'sp' ? 2 : 3;

      if (device === 'sp') {
        elementSizeModifySp("js-new-post-item-ttl", columnNum);
      } else {
        elementSizeModifyPcTab("js-new-post-item-ttl", columnNum);
      }
    });
  });
};

const movieShortContLeftResize = (isMobile) => {
  const movieShortCont = document.querySelector("#js-top-movie-cont");
  const movieShortSwiper = document.querySelector("#js-swiper-movie");
  if (movieShortCont && movieShortSwiper) {
    if (isMobile == "pc" || isMobile == "tab") {
      const computedStyle = window.getComputedStyle(movieShortCont);
      const movieShortContMarginLeft = computedStyle.marginLeft;
      // 'px'を取り除いて数値に変換
      const marginLeftValue = parseFloat(movieShortContMarginLeft);

      movieShortSwiper.style.left = `-${marginLeftValue + remToPx(2)}px`;
    } else {
      movieShortSwiper.style.left = `0px`;
    }
  }
};

// TOP interviewリンク連動
const items = document.querySelectorAll(".js-top-interview-item");

items.forEach((item) => {
  const link = item.querySelector(".top-interview__item-link");
  const btn = item.querySelector(".top-interview__item-btn");

  if (!link || !btn) return;

  const addHover = () => {
    link.classList.add("is-hover");
    btn.classList.add("is-hover");
  };

  const removeHover = () => {
    link.classList.remove("is-hover");
    btn.classList.remove("is-hover");
  };

  // linkとbtn連動させる
  [link, btn].forEach((el) => {
    el.addEventListener("mouseenter", addHover);
    el.addEventListener("mouseleave", removeHover);
  });
});